import { ArrowLeft, ArrowRight } from "lucide-react";
import LandingPageFooter from "../../organs/Landing/LandingPageFooter";
const CookiesPolicy = () => {
    return (
        <>
        <style>
            {`
            .cookies-container {
                display: flex;
                flex-direction: column;
                margin: 5rem 5rem 1rem 5rem;
                
                width: 100vw;

            }
                .cookies-text {
                width: 70%;
                }
                .cookies-back {
                text-decoration: none;
                color: black;
                }

                .cookies-heading{
                    opacity: 1;
                     transform: translateX(0px);
                    animation: footerTextIn 0.5s ease;
                }

                @keyframes footerTextIn {
                0% {opacity: 0; transform: translateX(-20px);}
                100% { opacity: 1; transform: translateX(0);}
                }
         
            `}
        </style>
        <div className="cookies-container">
            <a className="cookies-back" href="/"><ArrowLeft className="arrow-left"/></a>
            <h2 className="cookies-heading">Cookies</h2>
            <p className="cookies-text">archiCODE uses cookies for functional and analytical purposes. Cookies are small, locally stored, files that websites use to track information about users. For more information about cookies, please visit: https://cookiesandyou.com.</p>
            <p className="cookies-text">The main purpose of cookies placed by our website is to track user experience throughout the website. We save data about how users navigate the website, but are strict to never collect personally identifiable data. This means we don’t collect data like exact locations, ip-addresses and keystrokes. We collect the minimum amount of data required for our purposes and will never sell any of it to third parties. We do not use cookies to retarget, remarket or identify users in any way.</p>
            <p className="cookies-text">To effectively and safely process data collected we work with two data-processors (Google, recaptcha). Google and recaptcha are restricted from processing data without explicit request and prohibited from becoming a controller and processing and sharing the data any further.</p>
            <p></p>
            
        </div>
        <LandingPageFooter/>
        </>
    )
}

export default CookiesPolicy;